import React, { ChangeEvent, forwardRef, useState } from "react";
import { FormFeedback, Input, Label } from "reactstrap";
import classnames from "classnames";

interface Props {
  label?: string;
  name: string;
  placeholder?: string;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
  onBlur?: (e: ChangeEvent<HTMLInputElement>) => void;
  hasError?: boolean;
  errorText?: string;
  value: string;
  type?: "email" | "text" | "password" | "number";
  onTogglePassword?: (e:any) => void;
}

const LabelInput = forwardRef<HTMLInputElement, Props>((props, ref) => {
  const [showPass, setShowPass] = useState(false);

  const {
    label,
    value,
    name,
    placeholder,
    onChange,
    hasError,
    errorText,
    type = "text",
    onBlur,
    onTogglePassword
  } = props;

  const toggleShowPass = () => {
    if (type !== "password") {
      return;
    }
    setShowPass(!showPass);
    if (onTogglePassword) {
      onTogglePassword(!showPass);
    }
  };


  return (
    <div className="mb-3">
      <div className="form-floating">
        {type === "password" && (
          <div className="position-absolute h-100 d-flex align-items-center" style={{right: 10,  cursor: "pointer"}} onClick={toggleShowPass}>
            {showPass ? <i className="mdi mdi-eye-outline" /> : <i className="mdi mdi-eye-off" />}
          </div>
        )}

        <Input
          innerRef={ref}
          id={name}
          name={name}
          placeholder={placeholder}
          invalid={hasError}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          type={type === "password" ? (showPass ? "text" : type) : type}
        />
        {label && (
          <Label
            for={name}
            style={{"zIndex": 0}}
          >
            {value ? label : placeholder}
          </Label>
        )}
        <FormFeedback itemType="invalid">{errorText}</FormFeedback>
      </div>
    </div>
  );
});
LabelInput.displayName = 'LabelInput'
export default LabelInput;